export default function Header() {
  return (
    <div className="flex justify-center w-full">
      <h1 className="text-3xl font-extrabold text-center mb-6 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
        QR Code Generator
      </h1>
    </div>
  );
}
